export const notificationStudentMockData = [
  {
    uid: 1,
    time: "10 min ago",
    read: false,
    forEvolution: true,
    title: "مدارس التعاون",
    titleEn: "Altwon School",
    description:
      " رغبةً منا لتحسين الجودة ، و لمساعدة بقية أولياء الأمور في اختيار المدرسة المناسبة ندعوك لتقييم تجربتك في",
    descriptionEn:
      "Out of our desire to improve quality, and to help other parents choose the appropriate school, we invite you to evaluate your experience in the",
  },
  {
    uid: 1,
    time: "10 min ago",
    read: false,
    forEvolution: false,
    title: "مدارس التعاون",
    titleEn: "Altwon School",
    description: "لقد أصبحت المدرسة المفضلة متاحه للتسجيل ، سارع بالتسجيل",
    descriptionEn:
      "Your favorite school is now available for registration. Hurry up and register!",
  },
  {
    uid: 1,
    time: "10 min ago",
    read: false,
    forEvolution: false,
    title: "مدارس التعاون",
    titleEn: "Altwon School",
    description: "خصم خاص بمناسبة يوم التأسيس",
    descriptionEn: "Special discount on the occasion of founding day",
  },
  {
    uid: 1,
    time: "1 hour ago",
    read: true,
    forEvolution: false,
    title: "مدارس التعاون",
    titleEn: "Altwon School",
    description: "شكرا لكم للتسجيل في مدارس التعاون",
    descriptionEn: "Thank you for your registeration in Altwon School",
  },
];

export const notificationSchoolMockData = [
  {
    uid: 2,
    time: "10 min ago",
    read: false,
    forEvolution: false,
    title: "Abdullah",
    titleEn: "Abdullah",
    description: "لقد قام هذا المستخدم بتفضيل مدرستك",
    descriptionEn: "This user has favored / liked your school.",
  },
  {
    uid: 2,
    time: "10 min ago",
    read: true,
    forEvolution: false,
    title: "Ahmad",
    titleEn: "Ahmad",
    description: "لقد قام هذا المستخدم بتفضيل مدرستك",
    descriptionEn: "This user has favored / liked your school.",
  },
  {
    uid: 2,
    time: "10 min ago",
    read: true,
    forEvolution: false,
    title: "Saleh",
    titleEn: "Saleh",
    description: "لقد قام هذا المستخدم بتفضيل مدرستك",
    descriptionEn: "This user has favored / liked your school.",
  },
  {
    uid: 2,
    time: "12 min ago",
    read: true,
    forEvolution: false,
    title: "Norah",
    titleEn: "Norah",
    description: "لقد قام هذا المستخدم بتفضيل مدرستك",
    descriptionEn: "This user has favored / liked your school.",
  },
];
